"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '33%',
      borderRight: '1px solid',
      borderBottom: '1px solid',
      borderRightColor: theme.palette.another.grey,
      borderBottomColor: theme.palette.another.grey,
      color: theme.palette.another.grey,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      transition: 'all .2s ease',
      '& svg': {
        fill: theme.palette.another.grey
      },
      '&:hover': {
        color: theme.palette.text.primary,
        '& svg': {
          fill: theme.palette.text.primary
        }
      },
      '&:nth-of-type(3)': {
        borderRight: 'none'
      },
      '&:nth-of-type(4)': {
        borderBottom: 'none'
      },
      '&:nth-of-type(5)': {
        borderBottom: 'none'
      }
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
      padding: 0,
      width: 95,
      borderBottom: 'none',
      '&:nth-of-type(3)': {
        borderRightWidth: 1,
        borderRightColor: theme.palette.another.grey,
        borderRightStyle: 'solid'
      },
      '&:last-of-type': {
        borderRight: 'none'
      }
    }), (0, _defineProperty2.default)(_root, theme.breakpoints.up('lg'), {
      width: 121
    }), _root),
    colored: {
      color: theme.palette.text.primary,
      '& svg': {
        fill: theme.palette.text.primary
      }
    },
    label: (0, _defineProperty2.default)({
      fontSize: 12,
      textAlign: 'center',
      width: 80,
      marginTop: theme.spacing(1.5),
      textTransform: theme.text.textTransformUppercase,
      minHeight: theme.spacing(5)
    }, theme.breakpoints.up('lg'), {
      width: 100,
      fontSize: 14
    })
  };
}, {
  name: 'ProductDetailBarButton'
});

function ProductDetailBarButton(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      Icon = _ref.icon,
      isColored = _ref.isColored,
      label = _ref.label,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "icon", "isColored", "label"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement(_ButtonBase.default, (0, _extends2.default)({}, rest, {
    component: "a",
    className: (0, _clsx.default)(classes.root, className, isColored && classes.colored)
  }), /*#__PURE__*/_react.default.createElement(Icon, null), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.label
  }, label));
}

process.env.NODE_ENV !== "production" ? ProductDetailBarButton.propTypes = {
  classes: _propTypes.default.shape({
    colored: _propTypes.default.string,
    label: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  icon: _propTypes.default.func,
  isColored: _propTypes.default.bool,
  label: _propTypes.default.string
} : void 0;
ProductDetailBarButton.defaultProps = {
  classes: undefined,
  className: undefined,
  icon: undefined,
  isColored: undefined,
  label: undefined
};
var _default = ProductDetailBarButton;
exports.default = _default;